import { Row, Col, Form, Card, Table } from "react-bootstrap";
import LISTA_AUSILI_LIBERA from "const/listaAusiliLibera";

function TabellaLibera(props) {
	const lista = LISTA_AUSILI_LIBERA[props.sede];

	const change = (val) => {
		if (val.target.checked) {
			props.setPratica((prevPratica) => {
				let codex = [...prevPratica.codici, val.target.name];
				return { ...prevPratica, codici: codex };
			});
		} else {
			props.setPratica((prevPratica) => {
				let codAttuali = prevPratica.codici;
				for (var i = 0; i < codAttuali.length; i++) {
					if (codAttuali[i] === val.target.name) {
						codAttuali.splice(i, 1);
					}
				}

				return { ...prevPratica, codici: codAttuali };
			});
		}
	};

	return (
		<Row className="py-4">
			<Col>
				<Card>
					<Card.Header>
						<h3 className="text-center font-weight-bold">
							{props.tipo == "I" ? "TIPOLOGIA AUSILIO" : "LISTA AUSILI"}
						</h3>
					</Card.Header>
					<Card.Body>
						<Row style={{ textAlign: "center" }}>
							<Table responsive>
								<tbody>
									{lista.map((k, index) => {
										return (
											<tr key={index}>
												<td>
													<Col lg={4} xs={12}>
														<Form.Group style={{ textAlign: "center" }}>
															<Form.Check
																name={k.replace(/ /gi, "_")}
																checked={props.codici.includes(k.replace(/ /gi, "_"))}
																onChange={change}
															/>
														</Form.Group>
													</Col>
												</td>
												<td style={{ textAlign: "left" }}>
													<p>{k}</p>
												</td>
											</tr>
										);
									})}
								</tbody>
							</Table>
						</Row>
					</Card.Body>
				</Card>
			</Col>
		</Row>
	);
}

export default TabellaLibera;

// {lista.map((k,index)=>{
//   return <Col lg = {4} xs={12} key={index}> <Form.Group key={index} style={{textAlign:"center"}}>
//       <Form.Check
//   type="checkbox"
//   style={{ height: "2rem", width: "2rem", marginRight: "20px" }}
//   label={k.replace(/ /ig,"\u00A0")}
//   name={k.replace(/ /ig,"_")}
//   checked ={props.codici.includes(k.replace(/ /ig,"_"))}

//   onChange={change}

// />
// </Form.Group>
// </Col>
// })}
